<template>
  <form class="side_box" :style="style" @submit.prevent="stopEditing">
    <div v-if="!isEditing">
      <label for="Comments">Comments</label>
      <span v-if="this.details.comment">{{this.details.comment}}</span>
      <span v-else>  /  </span>
    </div>
    <div v-if="isEditing">
      <label for="Comments">Comments</label>
      <textarea v-model="comment"/>
    </div>
    <div v-if="!isEditing && this.userDetails.isAdmin == 1" class="icon submit" @click="startEditing">
      <BaseIcon name="pen" class="icon" />
    </div>
    <button v-if="isEditing" class="no-btn icon submit" type="submit">
      <BaseIcon name="save" class="icon" />
    </button>
  </form>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import InputDash from "@/components/base/InputDash.vue";

export default {
  components: {
    BaseIcon, 
    InputDash
  },
  computed: {
    style() {
      return "height: " + this.height + "%";
    },
    userDetails() {
      return this.$store.state.userDetails
    }
  },
  props: {
    height: String,
    details: Object
  },
  data() {
    return{
      isEditing: false,
      comment : ""
    }
  },
  mounted() {
    this.comment = this.details.comment
  },
  methods: {
    startEditing() {
      this.isEditing = true
    },
    putComment: function () {
      var that = this 
      this.$http.put(this.$endpoint + 'management/rawmaterials/editComment/' + this.details.rawMaterialID, {
        comment: this.comment
      })
      .then(function (response) {     
        that.$swal(
          'Raw material updated!',
          `Your Raw material has been successfully updated.`,
          'success'
        );
        that.$emit('refresh', true);
      })
      .catch(function (error) {
        that.$swal(
          'Oops that went wrong?',
          `Please contact the admin with the following info: ${ error }`,
          'error'
        );
      });
    },
    stopEditing() {
      this.isEditing = false
      this.putComment()
    },
  }
};
</script>

<style lang="scss" scoped>  
@import "@/style/base";
@import "@/style/components/sideBox";
@import "@/style/components/inputs";
@import "@/style/components/buttons";

.side_box {
  max-height: 252px;
}
</style>
